<template>
  <div>
    <header-div v-if="isshow"></header-div>
    <orgheader-div v-else></orgheader-div>
    <div class="container">
      <h2>当前位置：首页-新闻资讯</h2>
      <div style="min-height: 500px;">
        <div v-for="(item,index) in newList" :key="index" class="new-item" @click="toDetail(item.id)">
          <h3>{{item.title}}</h3>
          <p class="ovDuo2">{{item.describe}}</p>
          <div>发布时间：{{item.create_time}}</div>
        </div>
      </div>
      <div class="page-box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page.pageNum"
          :page-size="page.pageSize"
          layout="prev, pager, next, jumper"
          :total="page.pageTotal">
        </el-pagination>
      </div>
    </div>
    <footer-div v-if="isshow"></footer-div>
    <orgfooter-div v-else></orgfooter-div>
  </div>
</template>

<script>
  import headerDiv from '../pageMember/components/header'
  import footerDiv from '../pageMember/components/footer'
  import orgheaderDiv from '../pageOrg/components/header'
  import orgfooterDiv from '../pageOrg/components/footer'

  export default {
    data() {
      return {
        isshow: false,
        newList:[],
        page: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 1
        }
      }
    },
    created() {
      // 默认选择北京市
      this.$store.state.selectionAddress = window.sessionStorage.getItem('selectionAddress') ? JSON.parse(window.sessionStorage.getItem('selectionAddress')) : {
        categoryname: "北京市",
        city_id: 110100,
        parentid: 1,
        spell: "beijingshi"
      }
      if(JSON.parse(window.localStorage.getItem('user')) === null) {
        this.isshow = true
      }else{
        JSON.parse(window.localStorage.getItem('user')).user_type !== 2 ? this.isshow = true : this.isshow = false
      }
      this.getList()
    },
    methods: {
      toDetail(id){
        this.$router.push({
          path:'/newDetail',
          query:{
            id:id
          }
        })
      },
      getList(){
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        this.$api.apiContent.getNewList({
          page: this.page.pageNum,
          pageSize: this.page.pageSize
        }).then(res=>{
          res.data.map(item=>{
            item.create_time = this.$tools.ZHDate(new Date(item.create_time*1000))
          })
          this.newList = res.data
        })
      },
      getCookie(cname) {
        let name = cname + "="
        let ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i].trim()
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
          }
        }
        return ""
      },
      handleSizeChange(num) {        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num) {     //  选择页数
        this.page.pageNum = num
      },
      //  修改路径
      setPath() {
        this.$router.push({
          path: '/new',
          query: {
            pageNum: this.page.pageNum,
          }
        })
      },
    },
    components: {
      headerDiv,
      footerDiv,
      orgheaderDiv,
      orgfooterDiv
    },
    watch:{
      'page.pageNum'() {
        this.setPath()
      },
      $route() {
        this.getList()
      }
    }
  }
</script>

<style scoped lang="scss">
  .container{
    background: #fff;
    min-height:600px;
    margin: 30px auto;
    padding: 20px 30px;
    h2{
      line-height: 40px;
      border-bottom: 1px solid #ddd;
    }
  }
  .new-item{
    padding: 15px 0;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
    h3{
      line-height: 30px;
      font-size: 22px;
      margin-bottom: 10px;
    }
    p{
      color: #999;
      line-height: 30px;

    }
    div{
      color: #999;
      line-height: 30px;
    }
  }
</style>